// extracted by mini-css-extract-plugin
export default {"customInfoBox":"UserInfoPopup_customInfoBox__XiWHs"};